import React from 'react';
import {
  LuArmchair,
  LuBedDouble,
  LuBike,
  LuBriefcaseBusiness,
  LuDumbbell,
  LuHammer,
  LuLampFloor,
  LuMicrowave,
  LuPackage,
  LuPiano,
  LuRefrigerator,
  LuSofa,
  LuTable2,
  LuTv,
  LuWashingMachine,
} from 'react-icons/lu';
import { movdTokens } from './movdTokens.js';

const iconRules = [
  ['piano', LuPiano],
  ['bicycle', LuBike],
  ['exercise', LuDumbbell],
  ['sofa', LuSofa],
  ['couch', LuSofa],
  ['armchair', LuArmchair],
  ['chair', LuArmchair],
  ['bed', LuBedDouble],
  ['mattress', LuBedDouble],
  ['nightstand', LuLampFloor],
  ['lamp', LuLampFloor],
  ['tv', LuTv],
  ['television', LuTv],
  ['refrigerator', LuRefrigerator],
  ['fridge', LuRefrigerator],
  ['dishwasher', LuWashingMachine],
  ['washing machine', LuWashingMachine],
  ['dryer', LuWashingMachine],
  ['laundry', LuWashingMachine],
  ['microwave', LuMicrowave],
  ['stove', LuMicrowave],
  ['oven', LuMicrowave],
  ['table', LuTable2],
  ['desk', LuTable2],
  ['island', LuTable2],
  ['vanity', LuTable2],
  ['tool', LuHammer],
  ['workbench', LuHammer],
  ['computer', LuBriefcaseBusiness],
  ['printer', LuBriefcaseBusiness],
  ['filing', LuBriefcaseBusiness],
  ['safe', LuBriefcaseBusiness],
  ['office', LuBriefcaseBusiness],
];

export function MovdInventoryIcon({ item, size = 24, active = false }) {
  const name = String(item?.name || item || '').toLowerCase();
  const Icon = iconRules.find(([term]) => name.includes(term))?.[1] || LuPackage;
  return <Icon aria-hidden="true" size={size} strokeWidth={1.7} />;
}

export default function MovdInventoryCard({ item, quantity, onIncrease, onDecrease }) {
  const isSelected = quantity > 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: movdTokens.space[3], minHeight: 76, padding: movdTokens.space[3], background: isSelected ? movdTokens.color.brand.primaryLight : movdTokens.color.surface.base, border: `1px solid ${isSelected ? movdTokens.color.brand.primary : movdTokens.color.border.subtle}`, borderRadius: movdTokens.radius.md }}>
      <div style={{ display: 'flex', gap: movdTokens.space[3], alignItems: 'center' }}>
        <div style={{ width: 48, height: 48, borderRadius: movdTokens.radius.sm, background: isSelected ? '#DDF4F1' : movdTokens.color.background.muted, color: isSelected ? movdTokens.color.brand.primary : '#526373', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
          <MovdInventoryIcon item={item} active={isSelected} />
        </div>
        <div>
          <div style={{ color: movdTokens.color.content.primary, fontSize: movdTokens.typography.semantic.body, fontWeight: movdTokens.typography.weight.extrabold }}>{item.name}</div>
          {item.category && <div style={{ color: movdTokens.color.content.secondary, fontSize: movdTokens.typography.semantic.small }}>{item.category}</div>}
        </div>
      </div>
      <div style={{ display: 'flex', gap: movdTokens.space[2], alignItems: 'center' }}>
        <button type="button" onClick={onDecrease} aria-label={`Decrease ${item.name}`} style={{ width: 32, height: 32, border: `1px solid ${movdTokens.color.border.soft}`, background: movdTokens.color.surface.base, color: movdTokens.color.content.primary, borderRadius: movdTokens.radius.sm, fontSize: movdTokens.typography.semantic.body, cursor: 'pointer' }}>−</button>
        <div style={{ minWidth: 24, textAlign: 'center', color: movdTokens.color.content.primary, fontSize: movdTokens.typography.semantic.small, fontWeight: movdTokens.typography.weight.bold }}>{quantity}</div>
        <button type="button" onClick={onIncrease} aria-label={`Increase ${item.name}`} style={{ width: 32, height: 32, border: `1px solid ${movdTokens.color.brand.primary}`, background: movdTokens.color.brand.primary, color: movdTokens.color.brand.text, borderRadius: movdTokens.radius.sm, fontSize: movdTokens.typography.semantic.body, cursor: 'pointer' }}>+</button>
      </div>
    </div>
  );
}
